import { telephonyNavigationConfig } from "@/telephony/nav";
import { callTrackingNavigationConfig } from "@/call-tracking/nav";
import { adminNavigationConfig } from "@/admin/nav";
import { AppNavigation } from "@/shared/services/navigation";
import { offerCatalogNavigationConfig } from "@/offer-catalog/nav";

/** Define the navigation hierarchy */
export const navigationConfig: AppNavigation[] = [
  telephonyNavigationConfig,
  callTrackingNavigationConfig,
  offerCatalogNavigationConfig,
  adminNavigationConfig,
];
